import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useLoading } from 'react-simplikit';

import PageLoading from '@/components/Common/PageLoading';
import useFeedbackSourceStore from '@/stores/Feedback/FeedbackSourceStore';
import useLocaleStore from '@/stores/LocaleStore';
import useTagStore from '@/stores/TagStore';

import useProductStore from '../Product/store/ProductStore';

export default function PublicWorkspaceLayout() {
  const { workspace_id } = useParams();
  const fetchTag = useTagStore((state) => state.fetchAndCreateTagMap);
  const fetchProduct = useProductStore((state) => state.fetchProductList);
  const fetchSource = useFeedbackSourceStore(
    (state) => state.fetchFeedbackSources,
  );
  const fetchLanguageList = useLocaleStore((state) => state.fetchLanguageList);
  const fetchRegion = useLocaleStore((state) => state.fetchRegionMap);
  const [loading, startLoading] = useLoading();
  if (!workspace_id) throw new Error('Workspace ID is required');

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([
        fetchTag(workspace_id, true),
        fetchProduct(workspace_id, true),
        fetchSource(workspace_id, true),
        fetchLanguageList(workspace_id),
        fetchRegion(workspace_id),
      ]);
    };
    startLoading(fetchData());
  }, [
    fetchTag,
    fetchProduct,
    fetchSource,
    startLoading,
    fetchLanguageList,
    fetchRegion,
    workspace_id,
  ]);

  if (loading) return <PageLoading />;

  return <Outlet />;
}
